import { useMutation } from '@tanstack/react-query';
import { satisfactionSurveyRepository } from './satisfactionSurvey.repository';
import { SatisfactionSurveyResolution } from './satisfactionSurvey.types';

const SATISFACTION_SURVEY_MUTATION_SCOPE = { id: 'satisfaction-survey-views' };

export const useRegisterSatisfactionSurveyView = () =>
  useMutation({
    scope: SATISFACTION_SURVEY_MUTATION_SCOPE,
    mutationFn: async (orderId: string) => {
      const response = await satisfactionSurveyRepository.registerView(orderId);

      if (!response.ok) {
        throw response.originalError ?? new Error('failed to register survey display');
      }
    },
    retry: 1,
  });

interface RegisterResolutionParams {
  orderId: string;
  resolution: SatisfactionSurveyResolution;
}

export const useRegisterSatisfactionSurveyResolution = () =>
  useMutation({
    scope: SATISFACTION_SURVEY_MUTATION_SCOPE,
    mutationFn: async ({ orderId, resolution }: RegisterResolutionParams) => {
      const response = await satisfactionSurveyRepository.registerResolution(orderId, resolution);

      if (!response.ok) {
        throw response.originalError ?? new Error('failed to register survey resolution');
      }
    },
    retry: 1,
  });
